import {connect} from 'react-redux'
import _ from 'lodash'

import userUtil from '../util/user.util'

import {MobileHeader} from './mobileheader.component'

const mapStateToProps = (state) => {
    return {
        isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip']),
        lunatrip: state.getIn(['lunaTrip', 'trip']),
        currentUser: userUtil.getCurrentUser(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const MobileHeaderContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileHeader)

export default MobileHeaderContainer
